import { RawDraftContentState } from 'draft-js'
import { CheckState } from '../checks/reducer'
import { CommentsMap } from '../document/actions'

export const EN_US = 'en_US'
export const EN_GB = 'en_GB'
export const EN_AU = 'en_AU'
export const EN_CA = 'en_CA'
export type Locales = typeof EN_US | typeof EN_GB | typeof EN_CA | typeof EN_AU

export interface WfeLS {
  filename: string
  rawContentState: RawDraftContentState
  uploadId: string
  checks: CheckState
  selectedLocale: Locales
  comments: CommentsMap
  version: string
  plagiarismScore?: number
}



// WEBPACK FOOTER //
// ./src/state/session/types.ts